import { Component, EventEmitter, Input, OnDestroy, Output } from "@angular/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { AttachmentModel, UploadType } from "src/app/models/document.model";
import { FileService } from "src/app/services/file.service";

@Component({
  selector: "app-attachments-list",
  templateUrl: "./attachments-list.component.html",
  styleUrls: ["./attachments-list.component.scss"],
})
export class AttachmentsListComponent implements OnDestroy {
  @Input() attachments: AttachmentModel[] = [];
  @Input() label: string = "Attachments";
  @Input() showLabel: boolean = false;
  @Input() isEdit: boolean = true;

  @Output() attachmentDeleted: EventEmitter<string> = new EventEmitter<string>();
  @Output() attachmentDeleteFailed: EventEmitter<any> = new EventEmitter<any>();

  private readonly unsubscribe: Subject<void> = new Subject<void>();

  constructor(private readonly fileService: FileService) {}

  downloadAttachment(downloadUrl: string, fileName: string): void {
    this.fileService.fetchFile(downloadUrl, fileName);
  }

  deleteAttachment(id: string): void {
    this.fileService
      .delete(id, UploadType.Attachment)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: () => this.attachmentDeleted.emit(id),
        error: (error) => this.attachmentDeleteFailed.emit(error),
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
